import SectionHeading from "./SectionHeading";
import { featuredPicks } from "@/mocks/home";
import type { MovieDetail } from "../types";

interface FeaturedPicksProps {
  onOpen: (movie: MovieDetail) => void;
}

export default function FeaturedPicks({ onOpen }: FeaturedPicksProps) {
  return (
    <section id="featured" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="01"
          eyebrow="今日主推"
          title="今日午夜精选"
          desc="每天挑四部最贴合深夜气氛的片子，标题和一句话摘要对味了，再决定要不要进去。"
          actionHref="#latest"
          actionLabel="看完整片单"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featuredPicks.map((pick) => (
            <article
              key={pick.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/50 bg-background-100 transition-colors hover:border-primary-500/40"
            >
              <div className="relative h-[280px] w-full overflow-hidden bg-background-200">
                <img
                  src={pick.poster}
                  alt={`${pick.title} 午夜影院在线观看`}
                  title={`${pick.title} 午夜场片目`}
                  className="h-full w-full object-cover object-top opacity-85 transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
                <span className="font-label absolute left-3 top-3 rounded-md bg-background-50/85 px-2 py-1 text-lg leading-none text-primary-300">
                  {pick.rank}
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-background-50/85 px-2 py-1 text-xs text-primary-300">
                  <i className="ri-star-fill text-[11px]" />
                  {pick.score}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-display text-base font-bold text-foreground-950">{pick.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {pick.year} · {pick.genre} · {pick.duration}
                </p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-500">{pick.summary}</p>
                <button
                  type="button"
                  onClick={() => onOpen(pick)}
                  className="mt-4 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-circle-line" />
                  进入观看
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}